import type { Store } from './store';

/**
 * The single frontend home for per-state facts. Expanding to a new state is
 * one row here plus one `mapping` row in pkg/utils/timezone.go (the backend
 * drift guard — a state launched here but missing there emails on the
 * store's first sync).
 */
type StateInfo = {
  code: string;
  name: string;
  launched: boolean;
  swingDeals: boolean;
};

const STATES: StateInfo[] = [
  { code: 'AR', name: 'Arkansas', launched: true, swingDeals: false },
  { code: 'OK', name: 'Oklahoma', launched: true, swingDeals: true },
  { code: 'NY', name: 'New York', launched: true, swingDeals: false },
  { code: 'CO', name: 'Colorado', launched: true, swingDeals: false },
];

export const LAUNCHED_STATES = STATES.filter((s) => s.launched).map((s) => s.code);
export const LAUNCHED_STATE_NAMES = STATES.filter((s) => s.launched).map((s) => s.name);

function joinWithFinal(items: string[], final: string): string {
  if (items.length <= 1) {
    return items[0] ?? '';
  }

  return `${items.slice(0, -1).join(', ')} ${final} ${items[items.length - 1]}`;
}

/** "AR, OK, NY & CO" — for compact marketing copy. */
export const LAUNCHED_STATE_CODES_TEXT = joinWithFinal(LAUNCHED_STATES, '&');

/** "Arkansas, Oklahoma, New York and Colorado" — for prose marketing copy. */
export const LAUNCHED_STATE_NAMES_TEXT = joinWithFinal(LAUNCHED_STATE_NAMES, 'and');

/**
 * Swing deals are an Oklahoma market convention (post-and-hold pricing).
 * Frontend-only fact: it drives the four swing/buyup order columns and has
 * zero backend footprint.
 */
export function hasSwingDeals(store: Store): boolean {
  return STATES.find((s) => s.code === store.billing_address.state)?.swingDeals ?? false;
}
